import queryString from 'query-string'

export default {
  // Méthodes pures uniquement : les hooks mounted/watch qu'embarquait ce mixin
  // s'ajoutaient à ceux des composants (règles de fusion Vue) — getData tournait
  // deux fois dans DocumentApercu (double flux PDF, double webLog 'preview' dans
  // le Journal Web, source du lu/non-lu), et dans ArboDocs le getData du mixin
  // marquait « lu » l'id du DOSSIER à chaque affichage.
  methods: {
    documentUrl (id, version, fileIndex, params = {}) {
      params.token = this.$api.defaults.headers.common['Authorization'].substr(7)
      const url = `${this.$api.defaults.baseURL}inv/documents/${id}/${version}/${fileIndex}/?${queryString.stringify(params)}`
      return url
    },

    documentBase64 (id, version, fileIndex, params = {}) {
      params.token = this.$api.defaults.headers.common['Authorization'].substr(7)
      const data = `${this.$api.defaults.baseURL}inv/documents/${id}/${version}/${fileIndex}/?${queryString.stringify(params)}`
      return data
    },

    downloadDocument (id, version, fileIndex, params = {}, fileName) {
      // Document is now read — l'argument, pas this.id : dans ArboDocs, this.id
      // est l'id du dossier, et le document téléchargé n'était jamais marqué lu.
      this.$store.dispatch('addDocument', id)

      params['download'] = true
      params['filename'] = fileName

      const url = this.documentBase64(id, version, fileIndex, params)

      window.open(url)
    },
  },
}
